import { useEffect, useState } from "react";
import { useAppDispatch } from "Redux/store";
import { getDashboardReminders } from "Redux/Dashboard/reducer";
import { DashboardReminder } from "Shared/Types/dashboard";
import { LIMIT_DASHBOARD_REMINDER_PAGE } from "Shared/Constants/app";
import { ReminderType } from "./constants";

export const useReminderTable = (selectedType: ReminderType | "") => {
  const dispatch = useAppDispatch();
  const [dashboardReminders, setDashboardReminders] =
    useState<DashboardReminder | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let current = true;
    setLoading(true);
    setError(false);
    const params = {
      ...(selectedType ? { type: selectedType } : {}),
      offset: 0,
      limit: LIMIT_DASHBOARD_REMINDER_PAGE,
    };
    dispatch(getDashboardReminders(params))
      .unwrap()
      .then((data: DashboardReminder) => {
        if (current) setDashboardReminders(data);
      })
      .catch(() => {
        if (current) setError(true);
      })
      .finally(() => {
        if (current) setLoading(false);
      });
    return () => {
      current = false;
    };
  }, [dispatch, selectedType, attempt]);

  return {
    dashboardReminders,
    loading,
    error,
    retry: () => setAttempt((value) => value + 1),
  };
};
